export const ADD_TO_CART = 'Add To Cart';
export const BREAK_MOBILE = 767;
export const DISABLED = 'disabled';
export const FOCUSABLE_ELEMENTS = 'button, [href], input, select, textarea:not(.ada-hidden)';
export const OFF = 'off';
export const SOLD_OUT = 'Sold Out';
export const STOREFRONT_ACCESS_TOKEN = '423c07dc74351fddcbc7d53f64facc49';
export const SUBSCRIBE_SERVICE = 'https://homer-h2jz6ksnha-uc.a.run.app/';
